var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"rs-tag",class:{ 'rs-tag--long': _vm.long },attrs:{"data-shift":_vm.shift}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.long ? _vm.full : _vm.short))]),(!_vm.long)?_c('span',{staticClass:"rs-tag__sr"},[_vm._v(_vm._s(_vm.full))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }